COLORS = ['#A855A9', '#E2544B', '#F59500', '#FBC400', '#2ECC71', '#57C9C1', '#35ADE8']

App.CustomersGroupsChartComponent = Em.Component.extend
  classNames: ['customers-groups-chart']
  env: Em.inject.service('environment')

  didInsertElement: ->
    @_drawChart()

  _drawChart: ->
    dataset = @get('data').map((d) -> d.hovered = false; d)

    width = 155
    height = 155
    radius = Math.min(width-15, height-15) / 2
    totalSum = d3.sum(dataset.map (d) -> d.count)

    root = @$('.chart-container').get(0)


    svg = d3.select(root)
          .append('svg')
          .attr('width', width)
          .attr('height', height)

    # Основное полотно
    svgLayer = svg.append('g')
      .attr('transform', 'translate(' + (width / 2) +
            ',' + (height / 2) + ')')
      .attr('opacity', 1)
      .style('cursor','default')
      .style('-webkit-touch-callout', 'none')
      .style('-webkit-user-select', 'none')
      .style('-khtml-user-select', 'none')
      .style('-moz-user-select', 'none')
      .style('-ms-user-select', 'none')
      .style('user-select', 'none')

    # Полотно ховера
    hoverLayer = svg
      .append('g')
      .attr('class','hover-layer')
      .attr('transform', 'translate(' + (width / 2) +
            ',' + (height / 2) + ')')


    # Определяем размеры арок
    arc = d3.svg.arc()
          .outerRadius(radius)
          .innerRadius(radius - 10)

    hoverArc = d3.svg.arc()
          .outerRadius(radius + 15)
          .innerRadius(0)

    # Сетапим чарт
    pie = d3.layout.pie()
      .value((d) -> d.count)
      .sort(null)

    # Задаем каждый путь
    hoverPath = hoverLayer.selectAll('path')
      .data(pie(dataset))
      .enter()
      .append('path')
      .attr('id',(d,i) -> 'hover-path-'+i)
      .attr('cursor', 'pointer')
      .attr('d', hoverArc)
      .attr('fill', (d, i) -> COLORS[i % COLORS.length])
      .each((d) -> @_current = d)
      .attr('opacity',0)

    path = svgLayer.selectAll('path')
      .data(pie(dataset))
      .enter()
      .append('path')
      .attr('class','svg-path')
      .attr('id',(d,i) -> 'svg-path-'+i)
      .attr('cursor', 'pointer')
      .attr('d', arc)
      .attr('fill', (d, i) -> COLORS[i % COLORS.length])
      .each((d) -> @_current = d)

    # Текст по умолчанию
    defaultTextInfo = svgLayer.append('g')
      .attr('class', 'main-text-g')

    valueText = svgLayer.append('g')
      .attr('class', 'text-g')

    activeGroupText = valueText
      .append('text')
      .attr('class', 'text-info')
      .attr('text-anchor', 'middle')
      .attr('font-size', '12px')
      .attr('fill', '#7f7f7f')
      .attr('y', 20)

    defText = defaultTextInfo
      .append('text')
      .attr('class', 'main-text')
      .attr('text-anchor', 'middle')
      .attr('font-size', '12px')
      .attr('y', -4)

    # todo i18n
    defText.append('tspan').text('у вас')
    defText.append('tspan')
      .text(totalSum + ' ' + @get('env').translate('clients.clients_count',{count:totalSum}))
      .attr('x', 0)
      .attr('dy',17)

    text = valueText
      .append('text')
      .attr('class', 'text')
      .attr('text-anchor', 'middle')
      .attr('font-size', '40px')
      .attr('y', 0)

    thisComp = this;

    # Обработка событий
    hoverPath.on 'click', (d) =>
      @sendAction 'clickAction', d.data.type

    hoverPath.on 'mouseenter', (d) ->
      activeGroupText.text('')
      activeGroupText
        .append('tspan')
        .text(d.data.count+' '+
          thisComp.get('env').translate('clients.client_type.'+d.data.type, {count:d.data.count}))
        .append('tspan')
        .text(' ' + thisComp.get('env').translate('clients.clients_count',{count:d.data.count}))
        .attr('x', 0)
        .attr('dy', 14)
      id = '#svg-path-' + thisComp.$(@).attr('id').split('-')[2]
      thisComp.$('.svg-path:not('+id+')').css('opacity',0.3)
      thisComp.$('.main-text')
        .stop(true, true)
        .fadeOut(0)
      thisComp.$('.text-g').stop(true, true).fadeIn(300)
      text.text(Math.round((d.data.count/totalSum)*100)+'%')

    hoverPath.on 'mouseleave', (d, i) ->
      d3.select(@).attr('class', '')
      id = '#svg-path-' + thisComp.$(@).attr('id').split('-')[2]
      thisComp.$('.svg-path').css('opacity',1)
      thisComp.$('.text-g').stop(true, true).fadeOut(0)
      thisComp.$('.main-text').stop(true, true).fadeIn(300)
